"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newApi = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _url = require("../util/url.js");

var _templateObject;

var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse;
  return {
    getCmsPages: function () {
      var _getCmsPages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return amsResponse.getData({
                  method: "GET",
                  path: "v1.1/cms/pages"
                });

              case 2:
                data = _context.sent;
                return _context.abrupt("return", data || []);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getCmsPages() {
        return _getCmsPages.apply(this, arguments);
      }

      return getCmsPages;
    }(),
    getCmsPage: function () {
      var _getCmsPage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
        var pageName, locale, contractType;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                pageName = _ref2.pageName, locale = _ref2.locale, contractType = _ref2.contractType;
                return _context2.abrupt("return", amsResponse.getData({
                  method: "GET",
                  path: (0, _url.urlPath)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["v1.1/cms/page/", "/", "/", ""])), pageName, locale, contractType)
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getCmsPage(_x) {
        return _getCmsPage.apply(this, arguments);
      }

      return getCmsPage;
    }()
  };
};

exports.newApi = newApi;